var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _c(
        "div",
        [
          _c("base-label", {
            attrs: {
              label: _vm.label,
              labelClasses: _vm.labelClasses,
              disabled: _vm.disabled,
              required: _vm.required,
            },
          }),
          _c("input", {
            class: [
              "form-input pe-12 " + _vm.inputClasses,
              _vm.anyError ? "form-input-error" : "",
            ],
            attrs: {
              type: _vm.passwordType,
              placeholder: _vm.disabled ? "" : _vm.placeholder,
              autocomplete: _vm.newPassword ? "new-password" : "password",
              disabled: _vm.disabled,
              readonly: _vm.isReadOnly,
            },
            domProps: { value: _vm.localValue },
            on: {
              input: _vm.onInput,
              change: _vm.onChange,
              focus: _vm.onFocus,
              blur: _vm.onBlur,
              animationstart: _vm.animationStart,
              animationend: _vm.animationEnd,
            },
          }),
        ],
        1
      ),
      _c(
        "base-button",
        {
          staticClass: "absolute bottom-0 border-0 end-0",
          attrs: { type: "button", tabindex: "-1", disabled: _vm.disabled },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggleShowPassword.apply(null, arguments)
            },
          },
        },
        [
          _vm.passwordShown
            ? _c("svg-icon", { attrs: { name: "visibility-show" } })
            : _c("svg-icon", { attrs: { name: "visibility-hide" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }